module.exports = __webpack_public_path__ + "static/media/Monthly_CMIv1.0 - 2018-11-28.a8d4ea27.pdf";